import axios from 'axios';

const explicitBaseUrl = process.env.REACT_APP_BACKEND_API_BASE_URL?.trim();
const isProduction = process.env.NODE_ENV === 'production';

// Default to Fly.io in production, localhost in development. Allow env override.
const defaultBaseUrl = isProduction ? 'http://modulate-app-backend.fly.dev' : 'http://localhost:5001';

const api = axios.create({
  baseURL: explicitBaseUrl || defaultBaseUrl,
});

export default api;
